export default "__VITE_ASSET__2e47ce6a__"